import { Grid2 } from "@mui/material";
import { Sonho } from "../../types";
import { memoObserver } from "../../utils/memoObserver.utils";
import { CTable } from "../data-display/c-table.component";
import { ModalDeleteSonho } from "./modal-delete-sonhos.component";
import { ModalEditSonho } from "./modal-edit-sonhos.component";
import { ModalFormSonho } from "./modal-form-sonhos.component";

export interface TableSonhoProps {
  data: Sonho[];
  loading: boolean;
}

export const TableSonho = memoObserver(({ data, loading }: TableSonhoProps) => {
  return (
    <CTable
      title="Sonhos Realizados"
      addForm={() => <ModalFormSonho />}
      loading={loading}
      rows={data || []}
      columns={[
        {
          field: "title",
          headerName: "Titulo",
          width: 300,
        },
        {
          field: "local",
          headerName: "Local",
          width: 200,
        },
        {
          field: "actions",
          headerName: "Ações",
          type: "custom",
          width: 120,
          disableColumnMenu: true,
          sortable: false,
          renderCell(params) {
            return (
              <Grid2 container spacing={1}>
                <Grid2>
                  <ModalEditSonho id={params.row.id} />
                </Grid2>
                <Grid2>
                  <ModalDeleteSonho data={params.row} />
                </Grid2>
              </Grid2>
            );
          },
        },
      ]}
    />
  );
});
